import {FormattedMessage} from 'react-intl';
import {Sewage} from '.cache/__types__';

export const translations = {
    [Sewage.Undefined]: <FormattedMessage defaultMessage="Nespecifikováno" />,
    [Sewage.Public]: <FormattedMessage defaultMessage="Veřejná kanalizace" />,
    [Sewage.Cov]: <FormattedMessage defaultMessage="Vlastní čistička" />,
};
